"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var promise_retry_1 = __importDefault(require("promise-retry"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.retryExecFactory = function (func, retries) {
    if (retries === void 0) { retries = 3; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, promise_retry_1.default(function (retry, number) {
                    return func()
                        .catch(retry);
                }, { retries: retries })];
        });
    });
};
exports.CHAIN_GAS_STATION_V1 = {
    1: {
        url: 'https://ethgasstation.info/api/ethgasAPI.json?',
        modifiers: [function (data) { return ({
                blockNumber: data.blockNum,
                standard: new bignumber_js_1.default(data.average).div(10).toNumber(),
                safeLow: new bignumber_js_1.default(data.safeLow).div(10).toNumber(),
                fast: new bignumber_js_1.default(data.fast).div(10).toNumber(),
                fastest: new bignumber_js_1.default(data.fastest).div(10).toNumber()
            }); }]
    },
    80001: {
        url: 'https://gasstation.arianee.com/80001'
    },
    137: {
        url: 'https://gasstation.arianee.com/137'
    },
    77: {
        url: 'https://gasstation.arianee.com/77'
    },
    99: {
        url: 'https://gasstation.arianee.com/99'
    }
};
exports.fetchGasStation = function (chainId) { return __awaiter(void 0, void 0, void 0, function () {
    var obj, url, modifiers, response, data, modifiedData, _i, modifiers_1, modifier;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                obj = exports.CHAIN_GAS_STATION_V1[chainId.toString()];
                if (!obj) {
                    throw new Error("this chain is not handle " + chainId);
                }
                url = obj.url, modifiers = obj.modifiers;
                return [4 /*yield*/, exports.retryExecFactory(function () { return axios_1.default.get(url); })];
            case 1:
                response = _a.sent();
                data = response.data;
                modifiedData = data;
                if (modifiers) {
                    for (_i = 0, modifiers_1 = modifiers; _i < modifiers_1.length; _i++) {
                        modifier = modifiers_1[_i];
                        modifiedData = modifier(modifiedData);
                    }
                }
                return [2 /*return*/, modifiedData];
        }
    });
}); };
//# sourceMappingURL=index.js.map